import { lazy, Suspense, type ReactNode } from 'react';
import { WagmiProvider } from 'wagmi';
import { wagmiConfig } from '@/configs/bridge/wagmi';

// Lazy so @sodax/wallet-sdk-react stays out of the eager chunk. Pulling it
// eagerly evaluates the Node `util` polyfill before main.tsx's body sets
// `globalThis.process`, producing "process is not defined" on first paint.
const EvmSync = lazy(() => import('./EvmSync').then((m) => ({ default: m.EvmSync })));

export const EVMProviders = ({ children }: { children: ReactNode }) => {
  return (
    <WagmiProvider config={wagmiConfig}>
      <Suspense fallback={null}>
        <EvmSync />
      </Suspense>
      {children}
    </WagmiProvider>
  );
};
